import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HandleError } from '../../../../components/common/utils/handleError.component';
import { PolizaEntity } from '../../entities/polizas_cliente_entity';
import { VamTitularEntity, DependientesVam, Titulares, CambiosVam, CambiosVamDep } from '../../../vam/titulares/entities/vam_titulares_entity';
import { SolicitudInclusionService } from './solicitud-inclusion.service';
import { ExclusionEntity, PlanVam, ExclusionVam, Exclusiones } from '../../entities/vam_entities';
import { MovimientosVamService } from '../movimientos/movimientosVam.service';
import { SessionStorageService } from "ngx-webstorage";
import { SolicitudExclusionService } from './solicitud-exclusion.service';
import { UtilService } from '../../../../components/common/utils/util.service';
import { ClienteLogin } from '../../../login/cliente_login';
import { timeInterval } from 'rxjs/operator/timeInterval';
import { fail } from 'assert';
import { checkNoChangesNode } from '@angular/core/src/view/view';
import { CompleterService, CompleterData, CompleterItem } from 'ng2-completer';
import { LocalData } from 'ng2-completer/services/local-data';
import { SolicitudCambiosService } from './solicitud-cambios.service';
import { ListaDiccionaryEntity } from '../../../../components/common/utils/entities/lista_dictionary_entity';

const swal = require("sweetalert2");
declare var jQuery: any;

@Component({
    selector: 'solicitudCambios',
    templateUrl: 'solicitud-cambios.template.html'
})

export class SolicitudCambiosComponent implements OnChanges {
    @Input() polizaContratadaVam: PolizaEntity;
    @Input() planVam: number;
    @Input() planVamNombre: string;
    bandera: boolean;
    usuario: ClienteLogin;
    listaTitulares: VamTitularEntity[];
    showLoader: string;
    dataService: LocalData;
    titulares: Titulares[];
    searchStr: string;
    titularCambio: VamTitularEntity;
    Observaciones: string;
    ObservacionesDep: string;
    titularActual: VamTitularEntity;
    banderaDependiente: boolean;
    banderaFormDependiente: boolean;
    esDependienteBandera: any;
    dependienteActual: DependientesVam;
    dependienteCambio: DependientesVam;

    es: any = {
        firstDayOfWeek: 1,
        dayNames: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"],
        dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
        dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
        monthNames: ["enero", "febrero", "marzo", "abril", "mayo", "junio", 'julio', "agosto", "septiembre", "octubre", "noviembre", "diciembre"],
        monthNamesShort: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"]
    };
    yearRange: string;
    maxDate: Date;
    minDate: Date;

    yearRange1: string;
    maxDate1: Date;
    minDate1: Date;
    categorias: ListaDiccionaryEntity[];

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private handleError: HandleError,
        private cambiosService: SolicitudCambiosService,
        public utilsService: UtilService,
        public sesionStorageService: SessionStorageService,
        private completerService: CompleterService
    ) {
        this.listaTitulares = new Array<VamTitularEntity>();
        this.titulares = new Array<Titulares>();
        this.titularCambio = new VamTitularEntity();
        this.titularActual = new VamTitularEntity();
        this.dataService = completerService.local(this.titulares, 'NombreTitular', 'NombreTitular');
        this.banderaDependiente = false;
        let now = new Date(Date.now());
        let past = new Date(Date.now());
        past.setFullYear(past.getFullYear() - 50);
        this.yearRange = (now.getFullYear() - 50) + ":" + now.getFullYear();
        this.maxDate = now;
        this.minDate = past;

        this.bandera = false;
        let past1 = new Date(Date.now());
        past.setFullYear(past.getFullYear() - 1);
        this.yearRange1 = (now.getFullYear() - 1) + ":" + now.getFullYear();
        this.maxDate1 = now;
        this.minDate1 = past;
        this.categorias = new Array<ListaDiccionaryEntity>();
        this.dependienteActual = new DependientesVam();
        this.dependienteCambio = new DependientesVam();
        this.ObservacionesDep = "";
    }

    set dateS(e) {
        this.titularCambio.FechaNacimiento = new Date(e);
    }

    get dateS() {
        if (this.titularCambio.FechaNacimiento != undefined) {
            try {
                var a = this.titularCambio.FechaNacimiento.toISOString().substring(0, 10);
                var b = a.split("-");
                return b[2] + "/" + b[1] + "/" + b[0];
            } catch (e) {
                var a = this.titularCambio.FechaNacimiento.toString().substring(0, 10);
                return a;
            }
        }
    }
    set dateD(e) {
        this.dependienteCambio.FechaNacimiento = new Date(e);
    }

    get dateD() {
        if (this.titularCambio.FechaNacimiento != undefined) {
            try {
                var a = this.dependienteCambio.FechaNacimiento.toISOString().substring(0, 10);
                var b = a.split("-");
                return b[2] + "/" + b[1] + "/" + b[0];
            } catch (e) {
                var a = this.dependienteCambio.FechaNacimiento.toString().substring(0, 10);
                return a;
            }
        }
    }

    ngOnChanges() {
        this.polizaContratadaVam = jQuery.parseJSON(this.sesionStorageService.retrieve("polizaSelecionada"));
        
        this.usuario = jQuery.parseJSON(this.sesionStorageService.retrieve("usuario"));
        this.showLoader = "sk-loading";
        this.polizaContratadaVam.CodigoPlan = this.planVam;
        this.categorias = new Array<ListaDiccionaryEntity>();
        this.cambiosService.consultarTitularesDependientes(this.polizaContratadaVam).subscribe(
            result => {
                this.listaTitulares = result;
                this.titulares = new Array<Titulares>();
                this.listaTitulares.forEach(a => {
                    let titular = new Titulares();
                    titular.CodigoTitular = a.CodigoTitular;
                    titular.NombreTitular = a.PrimerNombre + " " + a.SegundoNombre + " " + a.ApellidoPaterno + " " + a.ApellidoMaterno;
                    this.titulares.push(titular);
                });
                this.dataService = this.completerService.local(this.titulares, 'NombreTitular', 'NombreTitular');
                this.cambiosService.consultarCategoriasVam(this.polizaContratadaVam).subscribe(
                    resultado => {
                        this.categorias = resultado;
                        this.showLoader = "";
                    },
                    error => {
                        this.handleError.redirectUrl(error);
                        this.showLoader = "";
                    }
                );
            },
            error => {
                this.handleError.redirectUrl(error);
                this.showLoader = "";
            }
        );
    }
    onSelected(e: CompleterItem) {
        if (e != null) {
            let tit = this.listaTitulares.filter(a => a.CodigoTitular == e.originalObject.CodigoTitular);
            this.titularCambio = new VamTitularEntity();
            this.titularActual = new VamTitularEntity();
            this.titularCambio = this.cloneCambio(tit[0]);
            this.titularActual = this.cloneCambio(tit[0]);
            this.bandera = true;
        }
    }
    solicitarCambio() {
        this.showLoader = "sk-loading";
        let cambio = new CambiosVam();
        cambio.TitularCambio = this.titularCambio;
        cambio.TitularActual = this.titularActual;
        cambio.Cliente = this.usuario;
        cambio.NombrePlan = this.planVamNombre;
        cambio.Poliza = this.polizaContratadaVam;
        cambio.Descripcion = this.Observaciones;
        this.cambiosService.enviarCambioVam(cambio).subscribe(
            result=>{
                swal({
                    title: 'Solicitud enviada exitosamente',
                    text: 'La solicitud de cambio se realizó correctamente',
                    type: 'success'
                }).then((function(){
                    this.bandera = false;
                    this.banderaDependiente = false;
                    this.banderaFormDependiente = false;
                    this.esDependienteBandera = false;
                    this.dependienteActual = new DependientesVam();
                    this.dependienteCambio = new DependientesVam();
                    this.titularActual = new VamTitularEntity();
                    this.titularCambio = new VamTitularEntity();
                    this.ObservacionesDep = "";
                    this.Observaciones = "";
                    this.searchStr = "";
                }).bind(this));
                this.showLoader = "";
            },
            error=>{
                this.handleError.redirectUrl(error);
                this.showLoader = "";
            }
        );
    }
    cloneCambio(c: VamTitularEntity) {
        let cambio = new VamTitularEntity();
        for (let prop in c) {
            cambio[prop] = c[prop];
        }
        return cambio;
    }
    cloneCambioDependiente(c: DependientesVam) {
        let cambioDependiente = new DependientesVam();
        for (let prop in c) {
            cambioDependiente[prop] = c[prop];
        }
        return cambioDependiente;
    }
    CambiarCategoria(e: number) {
        this.titularCambio.Categoria = this.categorias.filter(a => a.Codigo == e)[0].Nombre;
    }

    consultaDependientes(a: any) {
        if (this.bandera == true && this.banderaDependiente == false) {
            this.bandera = false;
            this.banderaDependiente = true;
            this.banderaFormDependiente = false;
        } else {
            if (this.bandera == false && this.banderaDependiente == true) {
                this.bandera = true;
                this.banderaDependiente = false;
                this.banderaFormDependiente = false;
            }
        }
    }
    getDependiente(e: DependientesVam){
        this.dependienteActual = this.cloneCambioDependiente(e);
        this.dependienteCambio = this.cloneCambioDependiente(e);
        this.banderaFormDependiente = true;
    }
    solicitarCambioDep(){
        this.showLoader = "sk-loading";
        let cambio = new CambiosVamDep();
        cambio.Titular = this.titularActual;
        cambio.Cliente = this.usuario;
        cambio.NombrePlan = this.planVamNombre;
        cambio.Poliza = this.polizaContratadaVam;
        cambio.Descripcion = this.ObservacionesDep;
        cambio.DependienteActual = this.dependienteActual;
        cambio.DependienteCambio = this.dependienteCambio;
        this.cambiosService.enviarCambioDependienteVam(cambio).subscribe(
            result=>{
                swal({
                    title: 'Solicitud enviada exitosamente',
                    text: 'La solicitud de cambio se realizó correctamente',
                    type: 'success'
                }).then((function(){
                    this.bandera = false;
                    this.banderaDependiente = false;
                    this.banderaFormDependiente = false;
                    this.esDependienteBandera = false;
                    this.dependienteActual = new DependientesVam();
                    this.dependienteCambio = new DependientesVam();
                    this.titularActual = new VamTitularEntity();
                    this.titularCambio = new VamTitularEntity();
                    this.ObservacionesDep = "";
                    this.Observaciones = "";
                    this.searchStr = "";
                }).bind(this));
                this.showLoader = "";
            },
            error=>{
                this.handleError.redirectUrl(error);
                this.showLoader = "";
            }
        );
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/vamEmpresa/solicitudes/solicitud-cambios.component.ts